/** Classificar e agrupar de uma vez, logo a seguir a detetar.
 *
 *  Os mesmos dois gestos do painel "Classificação e agrupamento"
 *  ("Classificar automaticamente" e "Agrupar"), com uma só leitura dos
 *  modelos e o agrupamento feito sobre a triagem já classificada (agrupar
 *  antes de a classificação acabar deixava de fora os marcadores que a
 *  classificação tira do âmbito: 103 grupos em vez de 102 no Cha139).
 *  Os pareceres manuais e de proposta ficam como estavam, como nos gestos
 *  do painel. */
import { useAppStore } from '@core/store'
import type { ClashResult } from '@viewer/clash/lib'
import { calcularGrupos, itensClassificados, lerEClassificar } from './clashClassificar'
import { clashKey } from './clashTriage'

export interface ResultadoDaArrumacao {
  aplicadas: number
  mantidas: number
  foraDoAmbito: number
  grupos: number
}

export async function classificarEAgrupar(
  results: readonly ClashResult[],
  opts: { signal?: { aborted: boolean }; onProgress?: (texto: string) => void } = {},
): Promise<ResultadoDaArrumacao> {
  const leitura = await lerEClassificar(results, useAppStore.getState().clashClassificacao, {
    signal: opts.signal,
    onProgress: (p) =>
      opts.onProgress?.(
        p.fase === 'propriedades'
          ? `A ler propriedades ${p.feitos}/${p.total}`
          : p.fase === 'geometria'
            ? 'A ler a geometria'
            : `A medir volumes comuns ${p.feitos}/${p.total}`,
      ),
  })
  if (opts.signal?.aborted) throw new Error('Cancelado.')
  const r = useAppStore.getState().classificarClashTriagem(itensClassificados(results, leitura))
  const st = useAppStore.getState()
  const grupos = calcularGrupos(results, leitura, st.clashTriage, st.clashClassificacao)
  st.agruparClashTriagem(grupos, new Set(results.map(clashKey)))
  st.setClashGroupBy('grupos')
  return { aplicadas: r.aplicadas, mantidas: r.mantidas, foraDoAmbito: r.foraDoAmbito, grupos: grupos.length }
}
